// Header component - appears at top of every page
// Shows logo, user name, and logout button


/**
 * What this component does:
 *  - Shows at top of every page
 *  - Displays welcome message with user name
 *  - Logout button that clears token and redirects to login
 */


import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { logout, getUser } from '../../utils/auth';
import '../../styles/components.css';

function Header({ onMenuClick }) {
  const navigate = useNavigate();
  const user = getUser();
  
  // Handle logout button click
  const handleLogout = () => {
    // Remove token and user info
    logout();
    
    // Redirect to login page
    navigate('/login');
  };
  
  return (
    <header className="header">
      <div className="header-content">
        {/* Left side - Mobile menu + Logo and title */}
        <div className="header-left">
          <button 
            className="mobile-menu-btn"
            onClick={onMenuClick}
            aria-label="Toggle menu"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div className="header-logo">
            <span className="logo-icon">P</span>
          </div>
          <h1 className="header-title">PLAN PARTICIPANT DASHBOARD</h1>
        </div>
        
        {/* Right side - User info and logout */}
        <div className="header-right">
          <span className="header-user">
            <i className="fas fa-user header-user-icon"></i>
            {user?.name || 'John User'}
          </span>
          <button 
            onClick={handleLogout}
            className="header-logout"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;